export default "__VITE_ASSET__MtAzSj6F__"